import { ApiMetadataRetriever, Collection, MixinInterface, StringUtil, ValueResolver } from "@mcleod/core";
import { Component } from "../base/Component";
import { getRelevantModelRow } from "../base/ComponentDataLink";
import { Layout } from "../components/layout/Layout";
import { ListenerListDef } from "../base/ListenerListDef";
import { TooltipContent } from "../page/tooltips/TooltipContent";

export class QuickInfoMixin extends Component implements MixinInterface {
    private _quickInfoLayout: string;
    public quickInfoOverrideKeyValue: any | (() => any);
    public quickInfoOverrideSearchMethod: (layout: Layout, keyValue: any) => Promise<void>;
    public quickInfoOverrideMethod: () => Promise<Component>;

    get name(): string {
        return "QuickInfo";
    }

    initialize() {
    }

    get listenerDefs(): Collection<ListenerListDef> {
        return null;
    }

    get quickInfoLayout(): string {
        if (this._quickInfoLayout == null && this._boundField?.lookupModel != null) {
            return ApiMetadataRetriever.getFromCache(this._boundField.lookupModel)?.quickInfoLayout;
        }
        return this._quickInfoLayout;
    }

    set quickInfoLayout(value: string) {
        this._quickInfoLayout = value;
        this.syncTooltipMouseListeners();
    }

    protected get loadedQuickInfoLayout(): TooltipContent {
        if (this.quickInfoOverrideMethod != null) {
            return this.quickInfoOverrideMethod();
        } else {
            return this.defaultQuickInfoMethod();
        }
    }

    private defaultQuickInfoMethod(): TooltipContent {
        return async (): Promise<Component> => {
            const keyValue = this.resolveKeyValue();
            if (StringUtil.isEmptyString(keyValue)) {
                return null;
            }
            const layout = this.getQuickInfoLayout();
            if (layout == null) {
                return null;
            }
            await layout.ensureLoaded();
            if (this.quickInfoOverrideSearchMethod != null) {
                await this.quickInfoOverrideSearchMethod(layout, keyValue);
            } else {
                await this.defaultSearchMethod(layout, keyValue);
            }
            return layout;
        };
    }

    private resolveKeyValue(): any {
        if (this.quickInfoOverrideKeyValue != null) {
            return ValueResolver.resolve(this.quickInfoOverrideKeyValue);
        }
        return this.getLookupModelResultValue();
    }

    private async defaultSearchMethod(layout: Layout, keyValue: any): Promise<void> {
        const metadata = await layout.mainDataSource.getMetadata();
        const keyField = metadata?.keyFields?.[0];
        if (keyField == null) {
            return;
        }
        await layout.mainDataSource?.search({ [keyField]: keyValue });
    }

    private getQuickInfoLayout(): Layout {
        if (this.quickInfoLayout != null) {
            return Layout.getLayout(this.quickInfoLayout);
        }
        return null;
    }

    private getLookupModelResultValue(): any {
        const row = getRelevantModelRow(this);
        const value = row?.get(this.field);
        return value;
    }

    protected getQuickInfoLayoutDefaultValue(): string {
        if (this._boundField?.lookupModel != null) {
            return ApiMetadataRetriever.getFromCache(this._boundField.lookupModel)?.quickInfoLayout;
        }
    }
}
